
import Component from '../../../assets/scripts/modules/component';
import insertScript from './../../../vendor/scripts/fabrique/modules/insert-script';
import randomHash from './../../../vendor/scripts/fabrique/modules/random-hash';

class Video extends Component {

  constructor() {
    super(...arguments);
  }

  init() {

    this.container = this.element.querySelector('.video__container');
    this.hitTarget = this.element.querySelector('.hit-target');
    this.autoplay = (this.element.getAttribute('data-autoplay') !== null);

    if (!this.container || !this.hitTarget) {
      return;
    }

    this.videoId = this.hitTarget.getAttribute('data-id');
    this.videoType = this.hitTarget.getAttribute('data-type');

    if (!this.videoId || !this.videoType) {
      return;
    }

    this.iframeId = `player-${randomHash()}`;
    this.player = null;

    this.initVideo();

  }

  initVideo() {

    this.hitTarget.addEventListener('click', this.onHitTargetClick.bind(this));

    if (this.autoplay) {
      window.setTimeout(() => this.hitTarget.click(), 50); // Arbitrary timeout to make sure the wrapper styling is painted first.
    }

  }

  onHitTargetClick(event) {

    event.preventDefault();

    if (this.videoType === 'vimeo') {
      insertScript('vimeo-api-script', /*'https://f.vimeocdn.com/js/froogaloop2.min.js'*/'https://player.vimeo.com/api/player.js', this.insertVimeoContainer.bind(this));
    } else if (this.videoType === 'youtube') {
      insertScript('youtube-api-script', 'https://youtube.com/iframe_api', this.insertYouTubeContainer.bind(this));
    } else {
      throw `Video #${this.videoId}: Video type "${this.videoType}" not supported`;
    }

  }

  insertVimeoContainer() {
    const iframe = document.createElement('iframe');

    iframe.id = this.iframeId;
    iframe.className = 'iframe is-hidden';

    iframe.addEventListener('load', () => {
      if (!window.Vimeo) {
        throw 'Vimeo API not loaded correctly.';
      }

      this.player = new window.Vimeo.Player(this.iframe);
      this.iframe = this.element.querySelector('iframe'); // Player might re-insert iframe

      this.onVimeoPlayerReady();
    });

    iframe.setAttribute('src', `//player.vimeo.com/video/${this.videoId}?byline=0&amp;title=0&amp;portrait=0&amp;loop=0&amp;autoplay=1&amp;autopause=1&amp;color=fff&amp;api=1&amp;player_id=${this.iframeId}`);

    this.hitTarget.parentNode.replaceChild(iframe, this.hitTarget);
    this.iframe = iframe;
    this.hitTarget = null;

  }

  insertYouTubeContainer() {
    const div = document.createElement('div');

    div.id = this.iframeId;
    div.className = 'iframe is-hidden';

    this.hitTarget.parentNode.replaceChild(div, this.hitTarget);
    this.iframe = div;
    this.hitTarget = null;

    window.onYouTubeIframeAPIReady = () => {
      this.player = new window.YT.Player(this.iframeId, {
        width: 640,
        height: 360,
        videoId: this.videoId,
        playerVars: { autoplay: 1, hd: 1, showinfo: 0, modestbranding: 1, 'iv_load_policy': 3, rel: 0, playlist: '' },
        events: {
          onReady: this.onYouTubePlayerReady.bind(this),
        },
      });
    };

  }

  onVimeoPlayerReady() {
    let safariTimeout;

    if (this.element.getAttribute('data-autoplay') !== null) {
      this.player.api('setVolume', 0);
      this.player.api('play');

      // Extra call to mute in Safari -- dirty
      try { this.iframe.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: 0 }), this.iframe.getAttribute('src').split(';')[0]); } catch(e) {}

      // And another few extra calls to mute in Safari -- dirtier
      [ 100, 200, 500, 1000 ].map((i) => {
        // WHY DONT YOU JUST MUTE SAFARI 😤
        window.clearTimeout(safariTimeout);
        safariTimeout = window.setTimeout(() => this.player.api('setVolume', 0), i);
      });
    }

    this.iframe.classList.remove('is-hidden');
    this.element.classList.add('is-playing');

  }

  onYouTubePlayerReady() {

    this.iframe = this.element.querySelector('iframe');
    this.player.setPlaybackQuality('hd1080');

    if (this.element.getAttribute('data-autoplay') !== null) {
      this.player.mute();
    }

    this.player.playVideo();
    this.iframe.classList.remove('is-hidden');
    this.element.classList.add('is-playing');

  }

}

for (const element of document.querySelectorAll('.video')) {
  element.instance = new Video('video', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/atoms/video/video.js